import PropTypes from 'prop-types';
import React from 'react';
import useTypewriter from '../../../../hooks/useTypewriter';
import MarkdownWithAssetLinks from './MarkdownWithAssetLinks';

/**
 * Component that displays text with a typewriter effect
 * @param {string} children - The text to display with typewriter effect
 * @param {number} speed - Speed in milliseconds between each word (default: 50ms)
 * @param {boolean} enabled - Whether the typewriter effect is enabled (default: true)
 * @param {function} onUpdate - Callback fired each time text updates (optional)
 */
function TypewriterText({ children, speed = 50, enabled = true, onUpdate = null }) {
  // Ensure we always have a string value, default to empty string if undefined/null
  const text = children || '';
  const displayedText = useTypewriter(text, speed, enabled, onUpdate);

  return <MarkdownWithAssetLinks>{displayedText}</MarkdownWithAssetLinks>;
}

TypewriterText.propTypes = {
  children: PropTypes.string.isRequired,
  speed: PropTypes.number,
  enabled: PropTypes.bool,
  onUpdate: PropTypes.func,
};

export default TypewriterText;
